// extracted by mini-css-extract-plugin
module.exports = {"link":"YSvtEf2Nw7hyN6ctEYx0L"};